import React, { useState } from 'react';
import { RefreshCcw, X } from 'react-feather';
import brushIcon from '../assets/brush.png';
import eraserIcon from '../assets/eraser.png';
import textIcon from '../assets/text.png';
import useLayersStore from '../stores/layersStore';
import { StageContext } from './DrawingCanvas';

const DrawModeSettings = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const stageRef = React.useContext(StageContext);
  const { 
    setIsDrawingMode,
    setIsExDrawingMode,
    currentTool, setCurrentTool,
    currentColor, setCurrentColor,
    brushSize, setBrushSize,
    clearCanvas,
    textNodes,
    addTextNode,
  } = useLayersStore();

  const getToolIcon = (tool) => {
    switch(tool) {
      case 'brush': return brushIcon;
      case 'eraser': return eraserIcon;
      case 'text': return textIcon;
      default: return brushIcon;
    }
  }


  const handleSave = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({ preferCurrentTab: true });
      const video = document.createElement("video");
      video.srcObject = stream;
      await video.play();
  
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0);
      
      // Stop all tracks
      stream.getTracks().forEach(track => track.stop());
      
      // Save the image
      const dataURL = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.download = "screenshot.png";
      link.href = dataURL;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to capture screenshot:", error);
    }
  };

  return (
    <div className="absolute top-24 right-24 bg-white/50 z-50 pointer-events-auto backdrop-blur-md rounded-md p-2 flex items-center space-x-2">
        <button
        className="w-10 h-10 cursor-pointer rounded-lg flex items-center justify-center relative text-gray-700"
        >
            <img 
                src={getToolIcon(currentTool)} 
                alt={currentTool.charAt(0).toUpperCase() + currentTool.slice(1)} 
                className="w-6 h-6" 
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            />
            <div className='absolute top-full rounded-b-md -left-2 w-14 items-center h-min mt-1 bg-white/50 p-2 gap-4 flex flex-col mix-blend-difference transition-all duration-300 overflow-hidden' 
                style={{maxHeight: isDropdownOpen ? undefined : 0, padding: isDropdownOpen ? undefined : 0}}>
                {['brush', 'eraser', 'text'].filter(tool => tool !== currentTool).map((tool) => (
                    <div key={tool} className='w-full h-full flex items-center justify-center'>
                        <img 
                            src={getToolIcon(tool)} 
                            alt={tool.charAt(0).toUpperCase() + tool.slice(1)} 
                            className="w-6 h-6" 
                            onClick={() => {
                                setCurrentTool(tool);
                            }}
                        />
                    </div>
                ))}
            </div>
        </button>
        <div className="relative">
          <button
            className="w-10 h-10 cursor-pointer rounded-lg flex items-center justify-center"
            style={{ backgroundColor: currentColor }}
            onClick={() => document.getElementById('colorPicker').click()}
          >
          </button>
          <input 
            type="color"
            id="colorPicker"
            value={currentColor}
            onChange={(e) => setCurrentColor(e.target.value)}
            className="absolute opacity-0 w-0 h-0"
          />
        </div>
        <button
          className="w-10 h-10 cursor-pointer rounded-lg flex items-center justify-center bg-white"
          onClick={() => setBrushSize(prev => Math.max(1, prev - 1))}
        >
            -
        </button>
        <div className='flex items-center justify-center'>
            {brushSize}
        </div>
        <button
          className="w-10 h-10 cursor-pointer rounded-lg flex items-center justify-center bg-white"
          onClick={() => setBrushSize(prev => Math.min(100, prev + 1))}
        >
            +
        </button>
        <button
          className="w-10 h-10 cursor-pointer rounded-lg flex items-center justify-center bg-white"
          onClick={clearCanvas}
        >
            <RefreshCcw />
        </button>
        <button
          className="w-10 h-10 cursor-pointer rounded-lg flex items-center justify-center bg-white"
          onClick={() => setIsDrawingMode(false)}
        >
            <X />
        </button>
        <button
          className="h-10 w-14 cursor-pointer rounded-lg flex items-center justify-center bg-white"
          onClick={handleSave}
        >
            Save
        </button>
    </div>
  );
};

export default DrawModeSettings; 